import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AvailabilityCalendar } from "../components/AvailabilityCalendar";
import { pageColors } from "../mock";
import { ArrowLeft, Link2, Check, CalendarDays } from "lucide-react";

export default function Availability() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [copied, setCopied] = useState(false);

  useEffect(() => { document.title = "TMM|AVAILABILITY"; }, []);

  const sharePage = async () => {
    const url = `${window.location.origin}/availability`;
    const text = `See who's available to collaborate at The Monde Mania: ${url}`;
    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 2000); };
    try {
      if (navigator.share) await navigator.share({ text });
      else await navigator.clipboard.writeText(url);
      done();
    } catch {
      try { await navigator.clipboard.writeText(url); done(); }
      catch { window.prompt("Copy this link:", url); }
    }
  };

  return (
    <>
      <Header hoverColor={pageColors.contact} compact={false} />
      <div className="feed-page avail-page" data-testid="availability-page">
        <button
          type="button"
          className="feed-back"
          onClick={() => navigate("/members")}
          data-testid="availability-back-btn"
        >
          <ArrowLeft size={16} /> Members
        </button>
        <div className="avail-page-head">
          <h1 className="avail-page-title" data-testid="availability-page-title">
            <CalendarDays size={26} /> Availability Calendar
          </h1>
          <p className="avail-page-sub">
            See who's open to collaborate and when. Members share their days — anyone can browse.
          </p>
          <button
            type="button"
            className="btn-ghost avail-share-page-btn"
            onClick={sharePage}
            data-testid="availability-share-page-btn"
          >
            {copied ? <><Check size={14} /> Link copied!</> : <><Link2 size={14} /> Share this page</>}
          </button>
        </div>
        <AvailabilityCalendar
          standalone
          initialProject={searchParams.get("project") || searchParams.get("availability") || ""}
        />
      </div>
    </>
  );
}
